import { FOOTER_REQUEST, FOOTER_SUCCESS, FOOTER_FAILURE } from '../../constants'

const initialState = {
  data: {},
  isLoading: true,
  error: null
}

const FooterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FOOTER_REQUEST:
      return {
        ...state,
        isLoading: true
      }

    case FOOTER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null
      }

    case FOOTER_FAILURE:
      return { ...state, isLoading: false, error: action.payload }

    default:
      return state
  }
}

export default FooterReducer
